import {
  Box,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export const UsersAndRolesPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            👥 Пользователи и роли
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Роль определяет, какие разделы видны в меню и какие действия доступны.
          </Text>
        </Box>

        <Box overflowX="auto">
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Роль</Th>
                <Th>Для кого</Th>
                <Th>Обычно доступно</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr><Td>Наблюдатель (V)</Td><Td>Контроль и просмотр</Td><Td>Просмотр графика и данных без редактирования</Td></Tr>
              <Tr><Td>Менеджер (M)</Td><Td>Операционная работа</Td><Td>График, объекты, отчёты</Td></Tr>
              <Tr><Td>Руководитель (L)</Td><Td>Управление командой</Td><Td>Настройки, пользователи, подписки</Td></Tr>
              <Tr><Td>Суперпользователь (S)</Td><Td>Администрирование</Td><Td>Полный доступ, включая админ-разделы</Td></Tr>
            </Tbody>
          </Table>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Практические советы</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheck} color="green.500" />Если не видите нужный раздел — вероятно, не хватает прав роли.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" />Изменение роли обычно делает руководитель или администратор.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" />Для личных данных и пароля используйте раздел «Профиль».</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
